import React from "react";
import styled from "styled-components";

const Container = styled.input<{ $isValid?: boolean }>`
  border-radius : 5px;
  border: 1px solid 
    ${({ $isValid }) =>
      $isValid === undefined || $isValid === null ? "#ccc" : $isValid ? "#ccc" : "#FF5A5A"};
  font-size: 16px;
  width: 100%;
  display: block;
  flex-grow: 1;
  padding: 10px 20px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0AB2E4; /* ✅ 포커스 시 테두리 색상 */
    box-shadow: 0 0 0 2px rgba(10, 178, 228, 0.2); /* 선택사항: 약간의 강조 효과 */
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
`

interface Props {
  type? :string;
  defaultValue?: string; 
  placeholder?: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  isValid? : boolean;
  pattern? : string;
  title? : string;
  disabled?: boolean
}

const InputBox = ({ placeholder, defaultValue, type, onBlur , isValid, pattern, title, disabled }: Props) => {

  return (
    <Wrapper>
    <Container
      type={type}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onBlur={onBlur}
      pattern={pattern}
      title={title}
      $isValid={isValid}
      disabled={disabled}
    />
    </Wrapper>
  );
};

export default InputBox;
